<div class="note_wrapper">
  <textarea [(ngModel)]="noteContent" class="note_content_style"></textarea>
  <div class="d-flex justify-content-center">
  <button class="note_btn" (click)="add()">{{'ORDER.SAVE_NOTE' | translate}}</button>
  </div>
</div>
